import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MaterialModule } from './material.module';
import { DatosEmisionComponent } from "./datos-emision/datos-emision.component"
import { DatosEmisionRenovacionComponent } from './datos-emision-renovacion/datos-emision.component'
import { DatosEmisionVehiculoComponent } from "./datos-emision-vehiculo/datos-emision-vehiculo.component"
import { DatosEmisionVehiculoRenovacionComponent } from "./datos-emision-vehiculo-renovacion/datos-emision-vehiculo.component"
import { InicioComponent } from "./inicio/inicio.component";
import { DatosTarjetaComponent } from "./datos-tarjeta/datos-tarjeta.component"
import { DatosTarjetaRenovacionComponent } from "./datos-tarjeta-renovacion/datos-tarjeta.component"
import { DatosVehiculoComponent } from "./datos-vehiculo/datos-vehiculo.component";
import { AutosBusquedaComponent } from "./datos-vehiculo/autos-busqueda/autos-busqueda.component";
import { IMaskModule } from 'angular-imask';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FinalComponent } from './final/final.component';
import { SimpleMessageComponent } from './tools/simple-message/simple-message.component';
import { LoginAyudaComponent } from './login-ayuda/login-ayuda.component';
import { PagoEnLineaComponent } from './datos-tarjeta/pago-en-linea/pago-en-linea.component';
import { PagoEnLineaRenovacionComponent } from './datos-tarjeta-renovacion/pago-en-linea/pago-en-linea.component';
import { NoEstaAutoComponent } from './datos-vehiculo/no-esta-auto/no-esta-auto.component';
import { DialogSioModule } from './tools/dialog/dialog-sio.module';
import { DirectiveModule } from './tools/directives/directive.module';
import { FooterModule } from './tools/footer/footer.module';
import { ToolbarModule } from './tools/toolbar/toolbar.module';
import { LoginModule } from './tools/login/login.module';
import { BuscadorCotizadorModule } from './tools/buscador-cotizador/buscador-cotizador.module';
import { LoginAuthComponent } from './login-auth/login-auth.component';
import { NotificacionComponent } from './tools/notificacion/notificacion.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from 'src/environments/environment';
import { PagoEnLineaGnpComponent } from './datos-tarjeta/pago-en-linea/pago-en-linea-gnp/pago-en-linea-gnp.component';
import { PagoEnLineaGnpRenovacionComponent } from './datos-tarjeta-renovacion/pago-en-linea/pago-en-linea-gnp/pago-en-linea-gnp.component';
import { PopUpComponent } from './pop-up/pop-up.component';
import { OpcionesSeguros } from './datos-emision-vehiculo/components/opciones-seguros.component';
import { CancelacionPolizaComponent } from './datos-emision-vehiculo/dialogs/cancelacion-poliza/cancelacion-poliza.component';
import { InicioCancelacionComponent } from './datos-emision-vehiculo/components/proceso-cancelacion/inicio-cancelacion/inicio-cancelacion.component';
import { AprobacionCancelacionComponent } from './datos-emision-vehiculo/components/proceso-cancelacion/aprobacion-cancelacion/aprobacion-cancelacion.component';
import { DatosCancelacionComponent } from './datos-emision-vehiculo/components/proceso-cancelacion/datos-cancelacion/datos-cancelacion.component';
import { FirmaCancelacionComponent } from './datos-emision-vehiculo/components/proceso-cancelacion/firma-cancelacion/firma-cancelacion.component';
import { InputFileComponent } from './datos-emision-vehiculo/components/input-file/input-file.component';

import { TruncateWordPipe } from './tools/pipes/truncate-word.pipe';

import { PagoEnLineaUmitecComponent } from './datos-tarjeta/pago-en-linea-umitec/pago-en-linea-umitec.component';
import { PagoEnLineaUmitecRenovacionComponent } from './datos-tarjeta-renovacion/pago-en-linea-umitec/pago-en-linea-umitec.component';
import { BasicAthInterceptor } from './tools/interceptors/basic-auth.interceptor';
@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    DatosVehiculoComponent,
    DatosEmisionComponent,
    DatosEmisionRenovacionComponent,
    DatosEmisionVehiculoComponent,
    DatosEmisionVehiculoRenovacionComponent,
    DatosTarjetaComponent,
    DatosTarjetaRenovacionComponent,
    DatosVehiculoComponent,
    AutosBusquedaComponent,
    FinalComponent,
    SimpleMessageComponent,
    NotificacionComponent,
    LoginAyudaComponent,
    PagoEnLineaComponent,
    PagoEnLineaRenovacionComponent,
    NoEstaAutoComponent,
    LoginAuthComponent,
    PagoEnLineaGnpComponent,
    PagoEnLineaGnpRenovacionComponent,
    PopUpComponent,
    PagoEnLineaUmitecComponent,
    PagoEnLineaUmitecRenovacionComponent,
    OpcionesSeguros,
    CancelacionPolizaComponent,
    InicioCancelacionComponent,
    AprobacionCancelacionComponent,
    DatosCancelacionComponent,
    FirmaCancelacionComponent,
    InputFileComponent,  
    TruncateWordPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    IMaskModule,
    DialogSioModule,
    DirectiveModule,
    FooterModule,
    ToolbarModule,
    LoginModule,
    BuscadorCotizadorModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    CommonModule
  ],
  entryComponents: [OpcionesSeguros],
  providers: [
    DecimalPipe,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
